export const environments = [
  {
    id: '',
    name: 'None',
    path: null,
    format: '.hdr'
  },
  {
    id: 'P11_Cage',
    name: 'P11_Cage',
    path: 'assets/environment/P11_Cage.png',
    format: '.png'
  },
  {
    id: 'P24_Cage',
    name: 'P24_Cage',
    path: 'assets/environment/P24_Cage.png',
    format: '.png'
  },
  {
    id: 'R9_Cage',
    name: 'R9_Cage',
    path: 'assets/environment/R9_Cage.png',
    format: '.png'
  },
  {
    id: 'B750_Cage',
    name: 'B750_Cage',
    path: 'assets/environment/B750_Cage.png',
    format: '.png'
  },
  {
    id: 'EP26_Cage',
    name: 'EP26_Cage',
    path: 'assets/environment/EP26_Cage.png',
    format: '.png'
  },
  // Default envmap, must placed as last
  {
    id: 'photo_studio_01_4k',
    name: 'photo_studio_01_4k',
    path: 'assets/environment/photo_studio_01_4k.hdr',
    format: '.hdr'
  },
];
